<template>
  <v-card>
    <!-- <approve-form @closeDialog="approve_dialog=false" :dialog="approve_dialog"></approve-form> -->
    <v-data-table
      :page.sync="page"
      @page-count="pageCount = $event"
      :items="students"
      :headers="headers"
      hide-default-footer
    >
      <template v-slot:item.name="{ item }">
        <span class="table-complete-name">{{item.name}}</span>
      </template>

      <template v-slot:item.group_code="{ item }">
        <span class="table-complete-group_code">{{item.group_code}}</span>
      </template>

       <template v-slot:item.group_session="{ item }">
        <span class="table-complete-group_code">
          {{ moment(item.group_session.session_date,'YYYY-MM-DD').format("DD-MM-YYYY") }}
        </span>
      </template>

      <template v-slot:item.session_no="{ item }">
        <span class="table-complete-session">{{item.session_no}}</span>
      </template>

      <template v-slot:item.days="{ item }">
        <span class="table-complete-days d-block">{{item.day}}</span>
        <span class="table-complete-days">{{item.date}}</span>
      </template>

      <template v-slot:item.time="{ item }">
        <span class="table-complete-time">{{item.time}}</span>
      </template>

      <template v-slot:item.action="{ item }">
        <v-btn @click="approve_dialog=true" small color="#F0CB00">{{ item.action }}</v-btn>
      </template>
    </v-data-table>
    <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Enquiries
        <span
          :style="{'color':this.$vuetify.theme.themes.light.primary}"
        >{{students.length}}</span>
      </span>
      <v-spacer></v-spacer>
      <v-pagination circle v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-card>
</template>

<script>
import ApproveForm from "./ApproveForm";
import moment from "moment";

export default {
  name: "CompleteTable",
  components: { ApproveForm },
  methods: {
    getZeroAddedNum(num) {
      return num.toString().padStart(2, "0");
    },
     getItems() {
           axios
        .get(apiRoutes.attendance.complete, {
        //   params: this.formQueryParams(),
        })
        .then((response) => {
            console.log("response")
            this.students = response.data.data
            // this.group_sessions = response.data.group_sessions
        //   this.formalizeTable(response.data);
        //   this.loading = false;
        });
    }
  },
   watch: {
    id: function(val) { // watch it
        //   console.log('Prop changed: ', val)
          console.log(val)

        if(val == 3){
        this.getItems()
        }
        }
  },
props: ['id'],
 mounted(){
        this.getItems()

  },
  data() {
    return {
      approve_dialog: false,
      page: 1,
      pageCount: 3,
      moment: moment,
      itemsPerPage: 10,
      headers: [
        { text: "Group Code", sortable: true, value: "group_session.group_id" },
        { text: "Student Name", value: "student.std_fname", sortable: true },
        { text: "Class", value: "group_session.group.class.class_name", sortable: true },
        { text: "Subject", value: "group_session.group.subject.subject_name", sortable: true },
        { text: "Tutor Name", value: "group_session.group.tutor.tutor_fname", sortable: true },
        { text: "Day & Date", value: "group_session", sortable: true },
        { text: "Time", value: "group_session.session_start_time", sortable: true },
        // { text: "Action", value: "action", sortable: true, align: "center" }
      ],
      students: [
        
      ]
    };
  }
};
</script>

<style lang="scss">
.v-data-table-header th span {
  font: 300 14px Gotham;
  font-family: "Gotham Narrow";
  color: #8898aa;
}

.table-complete {
  &-srno {
    font: 500 14px/13px Gotham;
    color: #172b4d;
  }
  &-name {
    display: block;
    font: 500 14px/13px Gotham;
    color: #6a158e;
  }
  &-group_code {
    font: 500 14px/13px Gotham;
    color: #0ebddff7;
  }
  &-time {
    display: block;
    font: 400 14px/10px Gotham;
    color: #0e0edff7;
  }
  &-days {
    font: 400 14px/15px Gotham;
    color: #172b4db3;
  }
  &-session {
    font: 500 14px/13px Gotham;
    color: #f0cb00;
  }
}
</style>

